import { createSearchEngine } from '../engine';

const QUERY_PARAMS = ['q', 'p'];

export const yahooSearch = createSearchEngine({
  safeParam: {
    key: 'vm',
    value: 'r',
  },
  isSearch: (url: URL): boolean => {
    return (
      /^(.*\.)?search\.yahoo\.com$/.test(url.hostname) &&
      /^\/search/.test(url.pathname) &&
      QUERY_PARAMS.some(param => url.searchParams.has(param))
    );
  },
});
